// extracted by mini-css-extract-plugin
export default {"mobileBasketFooter":"MobileBasketFooter_mobileBasketFooter__Mb4Pq"};